import * as TypeGraphQL from "type-graphql";
export var AuthenticatorScalarFieldEnum;
(function (AuthenticatorScalarFieldEnum) {
    AuthenticatorScalarFieldEnum["id"] = "id";
    AuthenticatorScalarFieldEnum["userId"] = "userId";
    AuthenticatorScalarFieldEnum["credentialID"] = "credentialID";
    AuthenticatorScalarFieldEnum["publicKey"] = "publicKey";
    AuthenticatorScalarFieldEnum["counter"] = "counter";
    AuthenticatorScalarFieldEnum["createdAt"] = "createdAt";
    AuthenticatorScalarFieldEnum["updatedAt"] = "updatedAt";
})(AuthenticatorScalarFieldEnum || (AuthenticatorScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AuthenticatorScalarFieldEnum, {
    name: "AuthenticatorScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AuthenticatorScalarFieldEnum.js.map